module.exports = __webpack_public_path__ + "img/lowWind.f214454b.svg";